{
  "aiCritiqueWorkingAlready": "Working already",
  "aiCritiqueDoThisNext": "Do this next",
  "aiCritiqueStillMissing": "Still missing",
  "aiCritiqueEveryoneElse": "Everyone else, in one line",
  "aiCritiqueRead": "Read →",
  "SectionsLeft": "sections left",
  "NextUpYourAnswer": "Next up: your answer",
  "NextUp": "Next up: {{name}}",
  "PreviousSection": "Previous section",
  "YourAnswer": "Your answer",
  "ThisBuilder": "This builder",
  "Builder": "Builder",
  "of": "of",
  "Intro": "Intro",
  "SkipToAnswer": "Skip to answer →",
  "BuilderProgress": "Builder progress",
  "SectionsRead": "sections read",
  "AnswerSaved": "saved",
  "AnswerInProgress": "in progress",
  "OnTrack": "On Track: ",
  "InGroup": "In Group: ",
  "switchTracks": "switch tracks",
  "switchTracksOrGroup": "switch track or group",
  "Progress": "Progress",
  "selectTrack": "select track",
  "selectTracksOrGroup": "select track or group",
  "Builders": "Builders",
  "JumpBackIn": "Jump back in...",
  "NoTrackSelected": "No Track Selected",
  "tracks": "tracks",
  "subject": "subject",
  "seeAllBuilders": "see all builders",
  "IntroTo": "Intro to ",
  "next": "Next ",
  "BackToBuilder": "Go Back to Builder Overview",
  "OverviewOf": "Overview of ",
  "steps": "steps",
  "Introduction": "Introduction",
  "Answer": "Answer",
  "Revisit": "Revisit",
  "Go": "Go >",
  "outOf1step": "out of 1 step",
  "outOf1steps": "out of 1 steps",
  "outOf": "out of ",
  "completed": "completed",
  "Review+Publish": "Review + Publish",
  "GoToReview+Publish": "go to review + publish",
  "NoAnswer": "no answers yet",
  "backToTopics": "Back to topics",
  "ConfirmLeavingPage": "Are you sure you want to leave this page without saving?",
  "ConfirmLeavingAnswerPage": "Are you sure you want to leave this page? Any unsaved work will be lost!",
  "ProfilePreview": "Review - Profile Preview",
  "done": "done",
  "Published": "Published",
  "editPublishSettings": "edit publish settings",
  "VisibleTo": "Visible to",
  "PublishSettings": "Publish settings",
  "Publish": "Publish",
  "ControlProfileAccess": "Control who can see this in your project profile",
  "selectVisibility": "Please select a visibility",
  "VisibilityOpt1": "Everyone",
  "VisibilityOpt2": "My Hubs, Groups, Events",
  "VisibilityOpt3": "My Events",
  "VisibilityOpt4": "Team Only",
  "VisibilityDetails": "? Visibility details",
  "VisibilityDetailsPart1": "Anyone viewing your profile can see this",
  "VisibilityDetailsPart2": "Anyone who is a member of a hub you belong to or anyone attending an event you're competing in can see this info on your profile",
  "VisibilityDetailsPart3": "Anyone attending an event you're competing in can see this info on your profile",
  "VisibilityDetailsPart4": "Only your team (including your support members) can see this info on your profile",
  "ViewOnProjectPage": "View On Project Page",
  "HeadsUp": "Heads up",
  "LastUpdated": "Last updated ",
  "by": "by",
  "save": "save",
  "back": "back",
  "finish": "finish",
  "someoneElseWorking1": "is working on this question. You can edit after they are done.",
  "someoneElseWorking2": " are also working on this builder.",
  "Step1Intro": "Step 1 - Introduction",
  "Step": "Step ",
  "backToBuilders": "back to all builders",
  "skipToAnswer": "skip to answer",
  "GotItNext": "Got it, next",
  "NoGoBack": "No, go back",
  "YesClose": "Yes, close",
  "addedToTheGroupHeader": "You were added to the group:",
  "addedToTheGroupMessage": "was automatically added to it, too.",
  "addedToTheGroupHint": "Hint: you can switch your project anytime in the group page.",
  "firstChoice": "Okay!",
  "DoNotAddProject": "Don't add a project",
  "SecondChoice": "Switch to another project",
  "LockedTopicTitle": "You must be part of a hub to see this content",
  "LockedTopicPhrasePart1": "Contact your school or company to see if they will sponsor your hub. Or you can",
  "ContactUs": "contact us",
  "LockedTopicPhrasePart2": "with any questions.",
  "ReadMore": "Read more...",
  "DifficultyLevel": "difficulty level:",
  "SeeGroupPage": "see group page",
  "NoScheduleYet": "No schedule set yet for this group.",
  "FaciliationTools": "Faciliation Tools",
  "FaciliationTools1": "Hub Launch Guide",
  "FaciliationTools2": "The RebelBase Curriculum, Builders and Hubs",
  "FaciliationTools3": "Builders Outline",
  "PastDue": "past due",
  "NextTrack": "next track >>",
  "OpenAs": "Open as",
  "editTopic": "edit topic",
  "rebelMapMinimize": "minimize",
  "rebelMapUnminimize": "unminimize",
  "rebelMapExpand": "expand",
  "rebelMapShrink": "shrink",
  "rebelMapMoveLeft": "move left",
  "rebelMapMoveRight": "move right",
  "rebelMapPdf": "pdf",
  "rebelMapInteractiveFile": "interactive file",
  "aiCritiqueTitle": "Critique panel",
  "aiCritiqueAnalyze": "Analyze",
  "aiCritiqueReanalyze": "Re-analyze",
  "aiCritiqueReviewing": "Reviewing…",
  "aiCritiqueNoFeedback": "This reviewer didn't return feedback in this run — try Re-analyze.",
  "aiCritiqueSpecialistCount": "{{count}} specialist perspectives",
  "aiCritiqueSubtitle": "A panel of specialists read your answer and push back",
  "aiCritiquePromptEmpty": "Add your answer above to run the critique.",
  "aiCritiquePromptReady": "Click Analyze to get AI feedback on your answer from a panel of specialists.",
  "aiCritiqueReviewingAcross": "Reviewing across {{count}} specialist perspectives…",
  "aiCritiqueTryAgain": "Try again",
  "aiCritiqueDismiss": "Dismiss",
  "aiCritiqueErrorBody": "Analysis timed out and couldn't finish. You weren't charged for this — try again.",
  "aiCritiqueSomeone": "A teammate",
  "aiCritiqueLockedAnalyzing": "{{who}} is analyzing this topic — results will appear for the whole team.",
  "aiCritiqueLockedEditing": "{{who}} is editing — Analyze is paused until they're done.",
  "aiCritiqueLimitBody": "You've used today's AI Critique budget — it resets tomorrow.",
  "aiCritiqueStaleBody": "Content updated since this analysis — re-analyze for fresh feedback.",
  "aiCritiqueChampion": "Champion",
  "aiCritiqueConfidence": "{{level}} confidence",
  "aiCritiqueKeyInsights": "Key insights",
  "aiCritiqueConcerns": "Concerns",
  "aiCritiqueRecommendations": "Recommendations",
  "aiCritiqueQuestions": "Questions for the team",
  "aiCritiqueInfoGaps": "Info gaps",
  "aiCritiqueStatusDone": "done",
  "aiCritiqueStatusReviewing": "reviewing",
  "aiCritiqueThanksHelpful": "Thanks — glad it was helpful.",
  "aiCritiqueThanksFeedback": "Thanks for the feedback.",
  "aiCritiqueUseful": "Was this critique useful?",
  "aiCritiqueHelpful": "Helpful",
  "aiCritiqueNotHelpful": "Not helpful",
  "aiCritiqueWhatBetter": "What could be better? (optional)",
  "aiCritiqueSkip": "Skip",
  "aiCritiqueSendFeedback": "Send feedback",
  "aiCritiqueLockedBusy": "Paused while a teammate is working on this topic.",
  "Copyright": "Copyright © {{year}} RebelBase, Inc. All rights reserved.",
  "Project": "Project",
  "TopicProgress": "Topic progress",
  "Section": "Section",
  "ThisTopic": "This topic",
  "aiCritiqueRun": "Run AI critique",
  "aiCritiqueRerun": "Re-run critique",
  "aiCritiqueEmptyTitle": "A panel of specialists, one read of your answer",
  "aiCritiqueEmptyReady": "Run the critique when you are ready. Each specialist flags concerns, asks the questions your team should answer, and names what is still missing.",
  "aiCritiqueIssuesToFix": "Issues to fix",
  "aiCritiqueCriticalCount": "{{count}} critical",
  "aiCritiqueHighCount": "{{count}} high",
  "aiCritiqueMediumCount": "{{count}} medium",
  "aiCritiqueNitsCount": "{{count}} nit",
  "aiCritiqueNitsCount_plural": "{{count}} nits",
  "aiCritiqueSpecialistPerspectives": "Specialist perspectives",
  "aiCritiqueFinish": "Finish"
}